import { MapContainer, TileLayer, GeoJSON, useMap } from "react-leaflet";
import L from "leaflet";
import { useRef, useEffect, useState } from "react";
import GenovaTripsTuttoInsieme from "./Genova_trips_TUTTO_INSIEME";
import NuvolaPunti from "./NuvolaPunti";
import { Tooltip as AntTooltip, Card, Spin } from "antd";
import IconMapa from "../assets/icons/MapaGeoJSON.svg";
import IconNuvola from "../assets/icons/NuvolaDiPunti.svg";
import PositionIcon from "../assets/icons/Vector.svg";
import ExchangeIcon from "../assets/icons/exchange.svg";
import { IoEarth } from "react-icons/io5";
import { BiVideoRecording } from "react-icons/bi";
import { FaMapLocationDot } from "react-icons/fa6";
import { RiMapPin2Fill } from "react-icons/ri";
import { TbTransformPoint } from "react-icons/tb";
import { MdClear } from "react-icons/md";
import VibrazioneSider from "../assets/icons/VibrazioneSider.svg";
import FlowIcon from "../assets/icons/CongestionSider.svg";
import TravelTimeIcon from "../assets/icons/AnomalySider.svg";
import RumorositaIcon from "../assets/icons/velocitaSider.svg";
import RumorositaSider from "../assets/icons/RumorositaSider.svg";
import useTrafficData from "../components/TrafficDataLoader";
import TrafficChartPopup from "../components/TrafficChartPopup";

import "../styles/mappa.css";
import { PiClipboardText } from "react-icons/pi";
// FIXED: Zoom buttons component that uses useMap hook
function ZoomButtons() {
  const map = useMap();

  return (
    <div className="zoom-buttons">
      <button
        onClick={() => map.zoomIn()}
        title="Zoom in"
        className="zoom-button"
      >
        +
      </button>
      <button
        onClick={() => map.zoomOut()}
        title="Zoom out"
        className="zoom-button"
      >
        -
      </button>
    </div>
  );
}
// FIXED: Current location button that uses useMap hook
function CurrentLocationButton() {
  const map = useMap();
  const markerRef = useRef(null);

  const handleClick = () => {
    if (!navigator.geolocation) {
      alert("Geolocalizzazione non supportata");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        map.flyTo([latitude, longitude], 18);

        if (markerRef.current) {
          map.removeLayer(markerRef.current);
        }

        const icon = L.icon({
          iconUrl: require("leaflet/dist/images/marker-icon.png"),
          iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
          shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41],
        });

        const newMarker = L.marker([latitude, longitude], { icon })
          .addTo(map)
          .bindPopup("Sei qui")
          .openPopup();

        markerRef.current = newMarker;
      },
      (error) => {
        console.error("Error getting location:", error);
        alert("Impossibile ottenere la tua posizione.");
      }
    );
  };

  return (
    <button
      onClick={handleClick}
      title="Vai alla mia posizione"
      className="current-location-button"
    >
      <img src={PositionIcon} alt="Current location" />
    </button>
  );
}

// FIXED: Map controls wrapper component
function MapControls() {
  return (
    <div className="map-controls">
      <CurrentLocationButton />
      <ZoomButtons />
    </div>
  );
}



function MapComponent({
  geoData,
  onFeatureSelect,
  styleFeature,
  speedDomain,
  siderSection,
  setSiderSection,
  showDeckGL,
  setShowDeckGL,
  mapMode,
  setMapMode,
  colorScale,
  availableDates,
  selectedDate,
  setSelectedDate,
  selectedHash,
  setSelectedHash,
  setSelectedFeature,
  footerOpen = true,
  footerHeight = 86.8,
  onRadarSelect,
  radarSelected,
  setRadarSelected,
  isLoadingGeoData = false,
  networkViewCategory,
  setNetworkViewCategory,
  networkViewDate,
  setNetworkViewDate,
  networkViewTime,
  setNetworkViewTime,
  availableNetworkDates,
  availableNetworkTimes,
}) {
  const mapRef = useRef();
  const [showDropdown, setShowDropdown] = useState(false);
  const [isSwitching, setIsSwitching] = useState(false);

  // Traffic data state
  const { stradeData, varchiData, loading: trafficLoading, error: trafficError } = useTrafficData();
  const [showTrafficChart, setShowTrafficChart] = useState(false);
  const [trafficChartData, setTrafficChartData] = useState(null);

  // Fix default marker icons path for Leaflet when adding geolocation marker
  // This is safe to call multiple times
  // eslint-disable-next-line no-underscore-dangle
  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  });

  // Initialize map size
  useEffect(() => {
    if (mapRef.current) {
      setTimeout(() => {
        mapRef.current.invalidateSize();
      }, 50);
    }
  }, []);

  // Recalculate map size whenever the footer visibility/height changes
  useEffect(() => {
    if (mapRef.current) {
      // Use a slightly longer timeout to ensure DOM has updated
      setTimeout(() => {
        mapRef.current.invalidateSize();
      }, 100);
    }
  }, [footerOpen, footerHeight]);

  // Additional resize handler for window resize events
  useEffect(() => {
    const handleResize = () => {
      if (mapRef.current) {
        setTimeout(() => {
          mapRef.current.invalidateSize();
        }, 50);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDropdown && !event.target.closest(".mode-dropdown")) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [showDropdown]);

  // Listen for showTrafficChart event from TrafficMarkers component
  useEffect(() => {
    const handleShowTrafficChart = (event) => {
      const { type, id } = event.detail;
      setTrafficChartData({ type, id });
      setShowTrafficChart(true);
    };

    window.addEventListener('showTrafficChart', handleShowTrafficChart);
    return () => window.removeEventListener('showTrafficChart', handleShowTrafficChart);
  }, []);

  // Expose function to select roads from network when clicking traffic polylines
  useEffect(() => {
    window.selectRoadFromNetwork = (streetName) => {
      if (!geoData) return;

      console.log('Selecting road from network:', streetName);

      // Find the road feature that matches this street name (case-insensitive, exact match preferred)
      const cleanStreetName = streetName.trim().toLowerCase();

      // First try exact match
      let matchingFeature = geoData.features.find(f => {
        const featureStreetName = (f.properties.StreetName || '').trim().toLowerCase();
        return featureStreetName === cleanStreetName;
      });

      // If no exact match, try partial match (but only if street names share significant overlap)
      if (!matchingFeature) {
        matchingFeature = geoData.features.find(f => {
          const featureStreetName = (f.properties.StreetName || '').trim().toLowerCase();
          // Only match if one contains the other AND they share at least 80% of the shorter name
          if (featureStreetName.includes(cleanStreetName) || cleanStreetName.includes(featureStreetName)) {
            const shorter = cleanStreetName.length < featureStreetName.length ? cleanStreetName : featureStreetName;
            const longer = cleanStreetName.length >= featureStreetName.length ? cleanStreetName : featureStreetName;
            // Calculate overlap ratio
            return shorter.length / longer.length >= 0.8;
          }
          return false;
        });
      }

      if (matchingFeature && onFeatureSelect) {
        console.log('Found matching feature:', matchingFeature.properties.StreetName, matchingFeature.properties.hash);
        const hash = matchingFeature.properties.hash;
        onFeatureSelect(hash, matchingFeature.properties);
      } else {
        console.log('No matching feature found for:', streetName);
      }
    };

    return () => {
      delete window.selectRoadFromNetwork;
    };
  }, [geoData, onFeatureSelect]);

  const handleModeChange = (mode) => {
    setIsSwitching(true);
    setMapMode(mode);
    setShowDropdown(false);

    setShowDeckGL(false);

    // brief spinner while switching view
    setTimeout(() => setIsSwitching(false), 400);
  };

  const handleDeselectAll = () => {
    // Clear all selected roads
    if (setSelectedHash) {
      setSelectedHash([]);
    }
    // Clear selected features
    if (setSelectedFeature) {
      setSelectedFeature([]);
    }
    // Deselect radar
    if (setRadarSelected) {
      setRadarSelected(false);
    }
    // Clear traffic markers
    // Close sider panel
    setSiderSection(null);
  };

  const onEachFeature = (feature, layer) => {
    const hash = feature.properties.hash;
    const isSelected = selectedHash && selectedHash.includes(hash);

    // Get value based on network view category
    const allRecords = feature.properties.allRecords || [];
    let rec;

    if (
      networkViewCategory &&
      networkViewDate &&
      networkViewTime &&
      (!selectedHash || selectedHash.length === 0)
    ) {
      // Find record matching both date and time
      rec = allRecords.find((d) => {
        if (d.day_group_label) {
          const dayGroupParts = d.day_group_label.split('_')[0];

          // Check if it's new format (YYYY-MM-DD)
          const newFormatMatch = dayGroupParts.match(/^(\d{4})-(\d{2})-(\d{2})$/);
          if (newFormatMatch) {
            // New format: direct comparison
            if (dayGroupParts === networkViewDate) {
              const recordTime = (d.t_start || '00:00') + ':00';
              if (recordTime === networkViewTime) {
                return true;
              }
            }
          } else {
            // Old format: parse DD,DD,DD-MM-YYYY
            const parts = dayGroupParts.split('-');
            if (parts.length === 3) {
              const daysStr = parts[0];
              const month = parts[1].padStart(2, '0');
              const year = parts[2];

              const days = daysStr.split(',');
              for (const day of days) {
                if (day && day.trim()) {
                  const dayPadded = day.trim().padStart(2, '0');
                  const recordDate = `${year}-${month}-${dayPadded}`;
                  if (recordDate === networkViewDate) {
                    // Also check time match
                    const recordTime = (d.t_start || '00:00') + ':00';
                    if (recordTime === networkViewTime) {
                      return true;
                    }
                  }
                }
              }
            }
          }
        }
        return false;
      }) || allRecords[0] || {};
    } else {
      rec = allRecords[0] || {};
    }

    // Determine which value to display
    let displayValue = "N/A";
    let displayLabel = "Speed";

    if (networkViewCategory === "velocita") {
      displayLabel = "Velocità";
      const speed = parseFloat(rec.AvgSp) || parseFloat(rec.speed) || 0;
      displayValue = speed > 0 ? Math.round(speed) + " km/h" : "N/A";
    } else if (networkViewCategory === "flow") {
      displayLabel = "Flow";
      const flow = (parseFloat(rec.Flusso_Espanso) || parseFloat(rec.flow) || 0) / 3;
      displayValue = flow >= 0 ? Math.round(flow) + " VEH/15min" : "N/A";
    } else if (networkViewCategory === "traveltime") {
      displayLabel = "Travel Time";
      const travelTime = parseFloat(rec.AvgTt) || parseFloat(rec.travel_time_in_seconds) || 0;
      displayValue = travelTime > 0 ? Math.round(travelTime) + " s" : "N/A";
    } else {
      // Default to speed
      const speed = parseFloat(rec.AvgSp) || parseFloat(rec.speed) || 0;
      displayValue = speed > 0 ? Math.round(speed) + " km/h" : "N/A";
    }

    // Bind tooltip to the layer
    const tooltipContent = `
      <div style="text-align: center;">
        <strong>Street Segment</strong><br/>
        <span style="font-size: 11px;">Hash: ${hash ? hash.substring(0, 8) : "N/A"
      }...</span><br/>
        <span style="font-size: 11px;">${displayLabel}: ${displayValue}</span>
      </div>
    `;

    layer.bindTooltip(tooltipContent, {
      permanent: isSelected, // Keep tooltip open when selected
      direction: "center",
      className: "street-tooltip",
      opacity: 0.9,
    });

    // Open/close tooltip based on selection
    if (isSelected) {
      layer.openTooltip();
    } else {
      layer.closeTooltip();
    }

    layer.on("click", () => {
      if (onFeatureSelect) {
        onFeatureSelect(hash, feature.properties);
      }
    });
  };

  return (
    <div
      style={{
        position: "relative",
        height: "100%",
        "--footer-height": footerOpen ? `${footerHeight}px` : "0px",
      }}
    >
      <div className="mode-dropdown" style={{ bottom: "300px" }}>
        <AntTooltip
          title="Seleziona modalità di visualizzazione"
          placement="left"
        >
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            className="mode-toggle-button"
          >
            {mapMode === "mappa" && (
              <div className="mode-option-icon">
                {" "}
                <FaMapLocationDot />
              </div>
            )}
            {mapMode === "flusso" && <RiMapPin2Fill alt="Flusso Completo" />}
            {mapMode === "nuvola" && <TbTransformPoint alt="Nuvola di Punti" />}
          </button>
        </AntTooltip>

        {showDropdown && (
          <Card className="mode-dropdown-menu" size="small" bordered={false}>
            <button
              onClick={() => handleModeChange("mappa")}
              className={`mode-option ${mapMode === "mappa" ? "active" : ""}`}
            >
              <div
                className="mode-option-icon"
                style={{ backgroundColor: "#FFE100" }}
              >
                <img src={IconMapa} alt="Mappa GeoJSON" />
              </div>
              <span className="mode-option-text">Vista Generale</span>
            </button>
            <button
              onClick={() => handleModeChange("flusso")}
              className={`mode-option ${mapMode === "flusso" ? "active" : ""}`}
            >
              <div
                className="mode-option-icon"
                style={{
                  backgroundColor: "#38f554ff",
                  color: "white",
                  fontSize: "15px",
                }}
              >
                <RiMapPin2Fill />
              </div>
              <span className="mode-option-text">Flussi</span>
            </button>
            <button
              onClick={() => handleModeChange("nuvola")}
              className={`mode-option ${mapMode === "nuvola" ? "active" : ""}`}
            >
              <div
                className="mode-option-icon"
                style={{ backgroundColor: "#353A0A" }}
              >
                <img src={IconNuvola} alt="Nuvola di Punti" />
              </div>
              <span className="mode-option-text">Nuvola di Punti</span>
            </button>
          </Card>
        )}
      </div>

      {mapMode !== "nuvola" && mapMode !== "flusso" && (
        <div className="sidebar-controls">
          {/* Determine if we have mixed selection (road + radar) */}
          {(() => {
            const hasRoads = selectedHash && selectedHash.length > 0;
            const hasRadar = radarSelected;

            // Show road buttons by default (no selection) or when at least 1 road is selected (without radar)
            const showRoadButtons = !hasRadar;
            // Show radar buttons only when radar is selected and no roads
            const showRadarButtons = hasRadar && !hasRoads;
            // Show Proprieta by default or when roads are selected (not mixed with radar)
            const showProprietaButton = !hasRadar;

            return (
              <>
                {/* Deselect All button - visible when any road or radar is selected */}
                {(hasRoads || hasRadar) && (
                  <button
                    onClick={handleDeselectAll}
                    disabled={mapMode !== "mappa"}
                    className="sidebar-button sidebar-button-deselect"
                    title="Deseleziona tutto"
                  >
                    <MdClear />
                  </button>
                )}

                {/* Info button - visible when any road or radar is selected */}
                {(hasRoads || hasRadar) && (
                  <button
                    onClick={() => {
                      if (mapMode === "mappa") {
                        setSiderSection(
                          siderSection === "info" ? null : "info"
                        );
                      }
                    }}
                    disabled={mapMode !== "mappa"}
                    className={`sidebar-button ${siderSection === "info" ? "active" : ""
                      }`}
                    title="Informazioni"
                  >
                    <PiClipboardText />
                  </button>
                )}

                {/* Proprieta button - visible only when elements of same type are selected */}
                {showProprietaButton && (
                  <button
                    onClick={() => {
                      if (mapMode === "mappa") {
                        if (hasRoads) {
                          // If roads are selected, show the sider
                          setSiderSection(
                            siderSection === "proprieta" ? null : "proprieta"
                          );
                        } else {
                          // If no roads, toggle network view category
                          if (networkViewCategory === "velocita") {
                            setNetworkViewCategory(null);
                          } else {
                            setNetworkViewCategory("velocita");
                            setSiderSection("velocita");
                          }
                        }
                      }
                    }}
                    disabled={mapMode !== "mappa"}
                    className={`sidebar-button ${(siderSection === "proprieta" && hasRoads) ||
                      (networkViewCategory === "velocita" && !hasRoads)
                      ? "active"
                      : ""
                      }`}
                    title="Velocità"
                  >
                    <img
                      src={RumorositaIcon}
                      alt="Velocità"
                      style={{ width: "20px", height: "20px" }}
                    />
                  </button>
                )}

                {/* Road-specific buttons - shown only when roads are selected (without radar) */}
                {showRoadButtons && (
                  <>
                    <button
                      onClick={() => {
                        if (mapMode === "mappa") {
                          if (hasRoads) {
                            // If roads are selected, show the sider
                            setSiderSection(
                              siderSection === "flow"
                                ? null
                                : "flow"
                            );
                          } else {
                            // If no roads, toggle network view category
                            if (networkViewCategory === "flow") {
                              setNetworkViewCategory(null);
                            } else {
                              setNetworkViewCategory("flow");
                              setSiderSection("flow");
                            }
                          }
                        }
                      }}
                      disabled={mapMode !== "mappa"}
                      className={`sidebar-button ${(siderSection === "flow" && hasRoads) ||
                        (networkViewCategory === "flow" && !hasRoads)
                        ? "active"
                        : ""
                        }`}
                      title="Flow"
                    >
                      <img
                        src={FlowIcon}
                        alt="Flow"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </button>

                    <button
                      onClick={() => {
                        if (mapMode === "mappa") {
                          if (hasRoads) {
                            // If roads are selected, show the sider
                            setSiderSection(
                              siderSection === "traveltime" ? null : "traveltime"
                            );
                          } else {
                            // If no roads, toggle network view category
                            if (networkViewCategory === "traveltime") {
                              setNetworkViewCategory(null);
                            } else {
                              setNetworkViewCategory("traveltime");
                              setSiderSection("traveltime");
                            }
                          }
                        }
                      }}
                      disabled={mapMode !== "mappa"}
                      className={`sidebar-button ${(siderSection === "traveltime" && hasRoads) ||
                        (networkViewCategory === "traveltime" && !hasRoads)
                        ? "active"
                        : ""
                        }`}
                      title="Travel Time"
                    >
                      <img
                        src={TravelTimeIcon}
                        alt="Travel Time"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </button>
                  </>
                )}

                {/* Radar-specific buttons - shown only when radar is selected (without roads) */}
                {showRadarButtons && (
                  <>
                    <button
                      onClick={() => {
                        if (mapMode === "mappa") {
                          setSiderSection(
                            siderSection === "audio" ? null : "audio"
                          );
                        }
                      }}
                      disabled={mapMode !== "mappa"}
                      className={`sidebar-button ${siderSection === "audio" ? "active" : ""
                        }`}
                      title="Rumorosità"
                    >
                      <img
                        src={RumorositaSider}
                        alt="Rumorosità"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </button>

                    <button
                      onClick={() => {
                        if (mapMode === "mappa") {
                          setSiderSection(
                            siderSection === "accelerometrici"
                              ? null
                              : "accelerometrici"
                          );
                        }
                      }}
                      disabled={mapMode !== "mappa"}
                      className={`sidebar-button ${siderSection === "accelerometrici" ? "active" : ""
                        }`}
                      title="Vibrazione"
                    >
                      <img
                        src={VibrazioneSider}
                        alt="Vibrazione"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </button>

                    <button
                      onClick={() => {
                        if (mapMode === "mappa") {
                          setSiderSection(
                            siderSection === "ambientali" ? null : "ambientali"
                          );
                        }
                      }}
                      disabled={mapMode !== "mappa"}
                      className={`sidebar-button ${siderSection === "ambientali" ? "active" : ""
                        }`}
                      title="Media giornaliera ambientale"
                    >
                      <IoEarth />
                    </button>

                    <button
                      onClick={() => {
                        if (mapMode === "mappa") {
                          setSiderSection(
                            siderSection === "video" ? null : "video"
                          );
                        }
                      }}
                      disabled={mapMode !== "mappa"}
                      className={`sidebar-button ${siderSection === "video" ? "active" : ""
                        }`}
                      title="Rilevamento di anomalie video"
                    >
                      <BiVideoRecording />
                    </button>
                  </>
                )}

                {/* Confronto button - always visible and clickable */}
                <button
                  onClick={() => {
                    if (mapMode === "mappa") {
                      if (!hasRoads && !hasRadar) {
                        // Show message when no elements are selected
                        alert(
                          "Nessun elemento selezionato. Seleziona almeno un elemento per visualizzare il confronto."
                        );
                      } else {
                        setSiderSection(
                          siderSection === "confronto" ? null : "confronto"
                        );
                      }
                    }
                  }}
                  disabled={mapMode !== "mappa"}
                  className={`sidebar-button-confronto ${siderSection === "confronto" ? "active" : ""
                    }`}
                  title="Confronto"
                >
                  <img src={ExchangeIcon} alt="" className="confronto-icon" />{" "}
                  Confronto
                </button>
              </>
            );
          })()}
        </div>
      )}

      {isSwitching && (
        <div className="map-loading-overlay">
          <Spin size="large" />
        </div>
      )}

      {isLoadingGeoData && mapMode === "mappa" && (
        <div className="map-loading-overlay">
          <Spin size="large" />
        </div>
      )}

      {mapMode === "flusso" ? (
        <>
          <GenovaTripsTuttoInsieme />
        </>
      ) : mapMode === "nuvola" ? (
        <>
          <NuvolaPunti />
        </>
      ) : (
        <>
          <MapContainer
            center={[44.309405, 9.352045]}  // Center of network_offset data bounds
            zoom={14}  // Adjusted zoom to show all network data
            maxZoom={22}
            zoomControl={false}
            style={{ height: "100%", width: "100%" }}
            whenCreated={(mapInstance) => {
              mapRef.current = mapInstance;
              // Initial size adjustment
              setTimeout(() => {
                mapInstance.invalidateSize();
              }, 100);
            }}
          >
            <TileLayer
              url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png"
              maxZoom={22}
              opacity={0.8}
            />
            {geoData && (
              <GeoJSON
                key={`${JSON.stringify(selectedHash)}-${networkViewCategory}-${networkViewDate}-${networkViewTime}`} // Force re-render when selection or time changes
                data={geoData}
                onEachFeature={onEachFeature}
                style={styleFeature}
                ref={(ref) => {
                  // Auto-fit map to data bounds on first load
                  if (ref && mapRef.current && !mapRef.current._boundsFitted && geoData.features && geoData.features.length > 0) {
                    try {
                      const bounds = ref.getBounds();
                      if (bounds && bounds.isValid()) {
                        // Fit bounds with some padding
                        mapRef.current.fitBounds(bounds, {
                          padding: [30, 30],
                          maxZoom: 15  // Don't zoom in too much
                        });
                        mapRef.current._boundsFitted = true;
                      }
                    } catch (e) {
                      console.log('Could not auto-fit bounds:', e);
                    }
                  }
                }}
              />
            )}

            {/* FIXED: Add controls as children of MapContainer */}
            <MapControls />
          </MapContainer>
        </>
      )}

      {/* Traffic Chart Popup */}
      {showTrafficChart && trafficChartData && (
        <>
          <div className="traffic-chart-overlay" onClick={() => setShowTrafficChart(false)} />
          <TrafficChartPopup
            type={trafficChartData.type}
            id={trafficChartData.id}
            stradeData={stradeData}
            varchiData={varchiData}
            onClose={() => setShowTrafficChart(false)}
          />
        </>
      )}
    </div>
  );
}

export default MapComponent;
